<template>
  <div class="footer">
    <div class="main-content">

      <ul class="nav-list">
        <li class="nav-item active">
          <a href="./">首页</a>
        </li>

        <li class="nav-divider"></li>
        <li class="nav-item">
          <a href="/channel">
            业务栏目
          </a>
        </li>

        <li class="nav-divider"></li>
        <li class="nav-item">
          <a href="/regulation">
            法律法规
          </a>
        </li>

        <li class="nav-divider"></li>
        <li class="nav-item">
          <a href="/help">
            帮助中心
          </a>
        </li>

        <li class="nav-divider"></li>
        <li class="nav-item">
          <a href="/platform">
            电子竞价平台
          </a>
        </li>

        <li class="nav-divider"></li>
        <li class="nav-item">
          <a href="/about">
            关于我们
          </a>
        </li>

      </ul>
      <div class="copyright">
        <p>版权所有：{{config.site_name}}</p>
        <p>Copyright {{config.site_copy}} <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #0080FF">{{config.miitbeian}}</a></p>
        <p>所有内容未经授权，不得转载或做其他使用，违者必究</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapActions,
    mapState,
    mapMutations
  } from "vuex";
  export default {
    name: "myfoot",
    data() {
      return {
        show: false,
        config:{}
      };
    },
    created() {
      this.init()
    },
    methods: {
      ...mapActions({
        getConfigIndex: "index/getConfigIndex",
      }),
      init(){
        this.getConfigIndex({
          data:{},
          success:(res) => {
            if(res.code == 1){
              this.config = res.data
            }
          },
        })
      },
    }
  }
</script>

<style scoped>
.footer {
    height: 180px;
    background: #fff;
    margin-top: 30px;
    font-size: 16px;
}

.footer .nav-list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.footer .nav-list .nav-item {
    cursor: pointer;
    line-height: 60px;
    width: 160px;
    text-align: center;
}
.footer .nav-list .nav-item>a {
    display: inline-block;
    height: 100%;
    width: 100%;
    font-size: 16px;
}
.footer .nav-list .nav-item>a:hover{
  text-decoration: underline;
}
.footer .nav-list .nav-divider {
    height: 24px;
    margin-top: 18px;
    border-left: 1px solid rgba(0,0,0,.2);
}
.footer .copyright {
    margin-top: 32px;
    text-align: center;
}
.footer .copyright p {
    margin: 0;
}

</style>
